import { KYMW9007Model } from '../kymw9007.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * パスワード再設定メール送信
 *
 * @export API通信成功時の処理
 * @class SendPasswordResetEmailService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class SendPasswordResetEmailService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9007Model;
  private successFunc: Function;
  private vo = {
    UserId: ''
  }

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof SendPasswordResetEmailService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        UserId: this.vo.UserId
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9007Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof SendPasswordResetEmailService
   */
  execute(model: KYMW9007Model, successFunc: Function) {
    this.model = model;
    this.vo.UserId = this.model.userId;
    this.successFunc = successFunc;
    this.send('sendPasswordResetEmail', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof SendPasswordResetEmailService
   */
  success(data: any) {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
